import * as callModel from '@gem/call/Model/callModel';
import { asyncCopyToClipboard } from '@gem/call/Removable/tasks/asyncCopyToClipboard';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';
import { copyTextToClipboard } from '@gem/utils';

const copyExistingLink = (inviteLink: string): void => {
  copyTextToClipboard(inviteLink);
  popupsTasks.showToast(t('common_link_copied'));
};

interface ICopyUnionCallLinkParams {
  inviteLink?: string;
  channelId?: string;
  copyCallback(inviteLink: string): void;
}
export const copyUnionCallLink = (params: ICopyUnionCallLinkParams): void => {
  if (params.inviteLink) {
    copyExistingLink(params.inviteLink);
    return;
  }

  if (!params.channelId) {
    return;
  }

  asyncCopyToClipboard({
    method: () => callModel.getUnionCallLink({ channelId: params.channelId || '' }),
    adapter: (response) => {
      params.copyCallback(response);

      return response;
    },
    successMessage: t('common_link_copied'),
    errorMessage: t('something_went_wrong'),
  });
};
